module.exports = __webpack_public_path__ + "img/studies_room_5.138be40b.svg";